// extracted by mini-css-extract-plugin
export default {"container":"SimplePaywallStep_container__DODJm","content":"SimplePaywallStep_content__vXPIY","footer":"SimplePaywallStep_footer__WAPl6","cta":"SimplePaywallStep_cta__VLYyu"};